import { Button } from "@mui/material";

const EventRegistrationSecondaryBtn = ({ children, ...props }) => {
  const sx = props?.sx || {};
  return (
    <Button
      {...props}
      variant="outlined"
      sx={{
        color: "#54086E",
        backgroundColor: "#fff",
        "&:hover": {
          backgroundColor: "#F4EAF8",
          borderColor: "#320147",
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export default EventRegistrationSecondaryBtn;
